export const PERMISSION_TREE = [
  { label: 'Dashboard', code: 'DASHBOARD' },
  {
    label: 'Bedelia',
    children: [
      { label: 'Estudiantes', code: 'BEDELIA_STUDENTS' },
      { label: 'Docentes', code: 'BEDELIA_TEACHERS' },
      { label: 'Reválidas', code: 'BEDELIA_REVALIDATIONS' },
      { label: 'Descuentos', code: 'BEDELIA_DISCOUNTS' },
      { label: 'Becas', code: 'FINANCE_SCHOLARSHIPS' },
    ],
  },
  {
    label: 'Dictados',
    children: [
      { label: 'Inscripciones', code: 'DICTATED_INSCRIPTIONS' },
      { label: 'Dictados', code: 'DICTATED_COURSES' },
    ],
  },
  {
    label: 'Exámenes',
    children: [
      { label: 'Inscripciones a exámenes', code: 'EXAM_INSCRIPTIONS' },
      { label: 'Exámenes', code: 'EXAMS' },
    ],
  },
  {
    label: 'Finanzas',
    children: [
      { label: 'Cuenta corriente', code: 'FINANCE_CURRENT_ACCOUNT' },
      { label: 'Aumentos de precio', code: 'FINANCE_PRICE_INCREASES' },
      { label: 'Empleados', code: 'FINANCE_EMPLOYEES' },
      { label: 'Planes de pago', code: 'FINANCE_PAYMENT_METHODS' },
      { label: 'Contratos de trabajo', code: 'FINANCE_CONTRACTS' },
      { label: 'Legajo digital', code: 'FINANCE_DOCUMENTS' },
      { label: 'Morosidad', code: 'FINANCE_DELINQUENCY' },
    ],
  },
  {
    label: 'Liquidaciones',
    children: [
      { label: 'Períodos de liquidación', code: 'PAYROLL_PERIODS' },
      { label: 'Calcular liquidación', code: 'PAYROLL_MANAGEMENT' },
      { label: 'Configurar aportes', code: 'PAYROLL_CONFIG' },
      { label: 'Aumentos salariales', code: 'PAYROLL_SALARY_INCREASES' },
      { label: 'Gestión de ausencias', code: 'PAYROLL_ABSENCES' },
    ],
  },
  {
    label: 'Marcas',
    children: [
      { label: 'Marcación', code: 'TIME_CLOCK' },
      { label: 'Reporte de marcas', code: 'TIME_CLOCK_REPORT' },
    ],
  },
  {
    label: 'Administración',
    children: [
      { label: 'Usuarios y roles', code: 'USER_MANAGEMENT' },
      { label: 'Auditoría', code: 'ADMIN_AUDIT' },
      { label: 'Reportes', code: 'ADMIN_REPORTS' },
      { label: 'Configuración institución', code: 'ADMIN_INSTITUTION' },
      { label: 'Sistema', code: 'ADMIN_SYSTEM' },
    ],
  },
  {
    label: 'Coordinación académica',
    children: [
      { label: 'Estudios', code: 'ACADEMIC_STUDIES' },
      { label: 'Tipos de estudio', code: 'ACADEMIC_STUDY_TYPES' },
      { label: 'Planes de estudio', code: 'ACADEMIC_STUDY_PLANS' },
      { label: 'Materias', code: 'ACADEMIC_SUBJECTS' },
      { label: 'Asistencia a cursos', code: 'ACADEMIC_ATTENDANCE' },
      { label: 'Calendario académico', code: 'ACADEMIC_CALENDAR' },
      { label: 'Aulas', code: 'ACADEMIC_CLASSROOMS' },
      { label: 'Importar escolaridades', code: 'ACADEMIC_IMPORT_ESCOLARIDAD' },
    ],
  },
  {
    label: 'Biblioteca',
    children: [
      { label: 'Medios', code: 'LIBRARY_MEDIA' },
      { label: 'Préstamos', code: 'LIBRARY_LOANS' },
    ],
  },
];

export function flattenPermissionCodes(nodes = PERMISSION_TREE) {
  const codes = [];
  nodes.forEach((node) => {
    if (node.code) codes.push(node.code);
    if (node.children?.length) codes.push(...flattenPermissionCodes(node.children));
  });
  return codes;
}

export function getPermissionLabel(code, nodes = PERMISSION_TREE) {
  for (const node of nodes) {
    if (node.code === code) return node.label;
    if (node.children?.length) {
      const label = getPermissionLabel(code, node.children);
      if (label !== code) return label;
    }
  }
  return code;
}

export function buildPermissionTreeWithIds(tree, accessByCode) {
  return tree
    .map((node) => {
      if (node.children?.length) {
        const children = buildPermissionTreeWithIds(node.children, accessByCode).filter(Boolean);
        if (!children.length) return null;
        return { label: node.label, children };
      }
      const access = accessByCode.get(node.code);
      if (!access) return null;
      return { id: access.id, code: access.access, label: node.label };
    })
    .filter(Boolean);
}
